// extracted by mini-css-extract-plugin
export default {"highlight":"Item_highlight--kjy","wrapper":"Item_wrapper--ouQ","icon":"Item_icon--SIc","title":"Item_title--DcI"};